<template>
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="item,index in bannerList" :key="index">
            <div class="m-banner" 
                v-if="bannerList"
                :style = "`background:url(${item.imgUrl});background-size:cover;`">
            <h3
                :style="getTitleStyle(item)"
                v-html='$getConfigText(item.title)'></h3>
            <!-- <p v-html='item.content'></p> -->
            <span
                v-show="item.isButton"
                :style="getBtnStyle(item)"
                @click="goPage(item.buttonJumpUrl)"
                v-html="$getConfigText(item.buttonText)"></span>
            </div>
        </van-swipe-item>
    </van-swipe>
</template>

<script>
    export default {
        name: 'MBanner',
        props:{
            bannerList:Array,
        },
        methods: {
            goPage(link) {
                window.location.href = link;
            },
            getTitleStyle(btnForm){
                return `color: ${btnForm.titleColor}`
            },
            getBtnStyle(btnForm){
                return `background:${btnForm.buttonColor};` +
                `color:${btnForm.buttonTextColor}`
            }
        },
    }
</script>

<style scoped lang='scss'>
     .my-swipe .van-swipe-item {
        .m-banner {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 10.4rem;
            background-size: cover;
            h3 {
                width: 8rem;
                font-size: 0.75rem;
                text-align: center;
                color: #333;
                margin: 1.7rem 0 3.1rem 0;
            }
            /* p {
                font-size: 0.37rem;
                text-align: center;
                line-height: 0.64rem;
                color: #333;
            } */
            span {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 3.41rem;
                height: 1.23rem;
                font-size: 0.43rem;
                font-weight: bold;
                border-radius: 0.16rem;
                color: #fff;
                
            }
        }
    }
    
</style>


// WEBPACK FOOTER //
// src/components/common/m-banner.vue